import React from "react";
import { motion } from "framer-motion";
import {
  IndustryIcon1,
  IndustryIcon2,
  IndustryIcon3,
  IndustryIcon4,
} from "../../../assets/svgs/icon";
import { useNavigate } from "react-router-dom";

const industriesData = [
  {
    id: 1,
    icons: IndustryIcon4,
    title: "Data Centers",
    desc: "Engineering and cooling solutions that enhance performance, reliability, and energy efficiency.",
    learnMore: "Learn More",
  },
  {
    id: 2,
    icons: IndustryIcon1,
    title: "Oil and Gas Industry",
    desc: "Engineering services and energy solutions supporting upstream, midstream, and downstream operations.",
    learnMore: "Learn More",
  },
  {
    id: 3,
    icons: IndustryIcon2,
    title: "Renewable Energy",
    desc: "Products and services that support clean, sustainable, and emerging energy technologies.",
    learnMore: "Learn More",
  },
  {
    id: 4,
    icons: IndustryIcon3,
    title: "Energy Services",
    desc: "Engineering expertise for developing, maintaining, and optimizing critical energy infrastructure.",
    learnMore: "Learn More",
  },
];

const Industries: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    window.scroll(0, 0);
    navigate("/services");
  };

  return (
    <div className="w-full h-auto flex flex-col items-center justify-center bg-backgroundColor py-10 px-2 md:px-10 ">
      {/* Header */}
      <div className="flex flex-col items-center justify-center md:px-24">
        <motion.h2
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="font-CrimsonText font-bold text-2xl md:text-4xl text-primaryColor pb-5"
        >
          Industries We Serve
        </motion.h2>
        <motion.p
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
          className="pb-5 font-CrimsonText font-normal text-base lg:text-xl text-textColor text-center"
        >
          At ECOCYNTEC, we support both the data center and energy industries
          with dependable engineering solutions. Our expertise spans advanced
          cooling and thermal management for data centers, as well as reliable
          services across upstream, midstream, and downstream energy operations.
          We are committed to delivering practical, efficient, and sustainable
          solutions that help our clients across both sectors operate safely,
          smoothly, and effectively.
        </motion.p>
      </div>

      {/* Industry Cards */}
      <div className="w-full md:w-3/5 lg:w-full flex-col xl:flex-row lg:flex items-center justify-between flex-nowrap gap-5 lg:gap-10 my-0 lg:my-10">
        {industriesData.map((card, index) => {
          const Icon = card.icons;
          return (
            <motion.div
              key={card.id}
              initial={{ y: 50, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="w-full h-72 lg:h-96 flex flex-col items-center justify-between p-3 my-5 lg:my-5"
            >
              <div className=" h-[30%]">
                <Icon />
              </div>
              <div className=" h-[60%] flex flex-col items-center justify-center">
                <h3 className="font-CrimsonText font-bold text-2xl text-center text-primaryColor">
                  {card.title}
                </h3>
                <p className="font-CrimsonText font-semibold text-textColor text-base lg:text-xl text-center">
                  {card.desc}
                </p>
                <div
                  className="flex items-center justify-center cursor-pointer"
                  onClick={handleNavigation}
                >
                  <span className="text-5xl text-primaryColor">-</span>
                  <h1 className="font-CrimsonText font-bold text-xl text-primaryColor">
                    {card.learnMore}
                  </h1>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default Industries;
